import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { useAdminParams } from 'utils/helpers';
import { ApiError, ViewData } from 'utils/types';
import { toastSuccess } from 'ui/partials/Toast';

import c from '../utils/constants';

type Payload = Omit<ViewData, '_id' | 'accountId' | 'dataList'>;

export default function useCreateViewData() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useMutation<ViewData, ApiError, Payload, any>({
    mutationFn: async ({ source, type, ...payload }: Payload) => {
      const api = new Api(args);
      const data = await api.post(
        await withAcl({
          account: {
            url: `/api/v3/views/data/${source}/${type}`,
            payload,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/views/data/${source}/${type}`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: (_, { source }: Record<string, any>) => {
      queryClient.invalidateQueries({ queryKey: [c.VIEW_DATAS, { source }] });
      toastSuccess('Successfully updated view');
    },
  });
}
